import React, { useState } from "react";
import UsrMenu from "./usrMenu";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import MenuIcon from "@mui/icons-material/Menu";
import Drawer from "@mui/material/Drawer";
import { Typography, Button } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/logo.png";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import BookIcon from "@mui/icons-material/Book";
import ListAltIcon from "@mui/icons-material/ListAlt";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import LogoutIcon from "@mui/icons-material/Logout"; 
import { AccountCircle } from "@mui/icons-material";
import { Persona } from "../../logic/domain/entities/persona";

interface TopAppBarProps {
  topBarLogOut: () => void;
  user:Persona
}

const TopAppBar: React.FC<TopAppBarProps> = ({ topBarLogOut, user }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const location = useLocation();
  const appVersion = process.env.REACT_APP_VERSION || "1.1";

  const isSelected = (path: string) => location.pathname.includes(path);

  const toggleDrawer = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (event.type === "keydown" && ((event as React.KeyboardEvent).key === "Tab" || (event as React.KeyboardEvent).key === "Shift")) {
      return;
    }
    setDrawerOpen(open);
  };

  return (
    <>
      <AppBar position="static" sx={{ background: "#00A3A8", boxShadow: "none" }}>
        <Toolbar sx={{ minHeight: "50px" }}>
          <IconButton 
            edge="start" 
            aria-label="menu" 
            onClick={toggleDrawer(true)}
            sx={{ color: "white" }}
          >
            <MenuIcon />
          </IconButton>
          <Box sx={{ display: "flex", justifyContent: "center", flexGrow: 1 }}>
            <img src={logo} alt="Logo" style={{ height: 35 }} />
          </Box>

          <Box sx={{ mr: -1.5 }}>
            <UsrMenu onLogoutFromMenu={topBarLogOut} user={user}/>
          </Box>
        </Toolbar>
      </AppBar>
      <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "100%",
          }}
          role="presentation"
        >
          <Box sx={{ flexGrow: 1 }}>
           
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", padding: 2, pt: 3 }}>
              <IconButton>
                <AccountCircle sx={{ fontSize: 100 }} />
              </IconButton>
              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                {user.getNombre()+" "+user.getApellido()}
              </Typography>
              <Typography variant="body2" sx={{ color: "text.secondary", mb: 2 }}>
                {user.getTipo()} - {user.getNroDoc()}
              </Typography>
            </Box>
            <Divider />
            <List>
              <ListItemButton 
                component={Link} 
                to="/dashboard/listadoprestaciones" 
                onClick={toggleDrawer(false)}
                selected={isSelected("/listadoprestaciones")}
              >
                <ListItemIcon sx={{ minWidth: 32 }}>
                  <BookIcon />
                </ListItemIcon>
                <ListItemText primary="Listado de prestaciones" />
              </ListItemButton>
              <Divider />
              <ListItemButton 
                component={Link} 
                to="/dashboard/listadoprotocolos" 
                onClick={toggleDrawer(false)}
                selected={isSelected("/listadoprotocolos")}
              >
                <ListItemIcon sx={{ minWidth: 32 }}>
                  <ListAltIcon />
                </ListItemIcon>
                <ListItemText primary="Listado de protocolos" />
              </ListItemButton>
              <Divider />
              <ListItemButton 
                component={Link} 
                to="/dashboard/infocuenta" 
                onClick={toggleDrawer(false)}
                selected={isSelected("/infocuenta")}
              >
                <ListItemIcon sx={{ minWidth: 32 }}>
                  <AccountBoxIcon />
                </ListItemIcon>
                <ListItemText primary="Información de la cuenta" />
              </ListItemButton>
            </List>
            <Divider />
          </Box>
          <Box>
            <Divider />
            <Box sx={{ padding: 2, pb: 1 }}>
              <Button
                variant="contained"
                fullWidth
                startIcon={<LogoutIcon sx={{ fontSize: '18px' }} />}
                onClick={() => {
                  setDrawerOpen(false);
                  topBarLogOut();
                }}
                sx={{
                  bgcolor: '#d32f2f',
                  '&:hover': { bgcolor: '#b71c1c' },
                  color: 'white',
                  textTransform: 'none',
                  py: 0.75,
                  fontSize: '0.875rem',
                }}
              >
                Cerrar Sesión
              </Button>
            </Box>
          </Box>
          <Box sx={{ padding: 2, textAlign: "center", backgroundColor: "#f5f5f5" }}>
            <Typography variant="caption" sx={{ display: "block", color: "text.secondary", fontSize: "0.65rem", mb: 0.3 }}>
              Versión {appVersion}
            </Typography>
            <Typography variant="caption" sx={{ display: "block", color: "text.secondary", fontSize: "0.65rem" }}>
              © Lachybs
            </Typography>
          </Box>
        </Box>
      </Drawer>
    </>
  );
};

export default TopAppBar;
